import { render, staticRenderFns } from "./ConsentOnePlatformIndex.vue?vue&type=template&id=5c087fa9&scoped=true&"
import script from "./ConsentOnePlatformIndex.vue?vue&type=script&lang=js&"
export * from "./ConsentOnePlatformIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConsentOnePlatformIndex.vue?vue&type=style&index=0&id=5c087fa9&prod&lang=css&"
import style1 from "./ConsentOnePlatformIndex.vue?vue&type=style&index=1&id=5c087fa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c087fa9",
  null
  
)

export default component.exports